import { defineComponent as _defineComponent } from 'vue'
import { AffiliateInvoiceInfo, IAffiliateInvoice } from "@/api/types/payout";
import { getAffiliateSearch } from "@/api/user";
import BaseEditableCard from "@/components-UI/BaseEditableCard.vue";
import BaseListV2 from "@/components-UI/list/BaseListV2.vue";
import { AffiliateInvoiceCards, useAffiliateInvoiceSingle } from "@/services/TablePage/affiliateInvoices";
import { showServerError } from "@/utils";
import { computed, onBeforeMount, ref } from "vue";

interface Props {
    invoice: IAffiliateInvoice
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AffiliateInvoiceInfo',
  props: {
    invoice: null
  },
  setup(__props: any) {

const props = __props as {
    invoice: IAffiliateInvoice
}



const affiliate = ref({});
const cards = ref<AffiliateInvoiceCards | null>(null);

onBeforeMount(async () => {
    await getAffiliateInfo();
    const { getCards } = useAffiliateInvoiceSingle(getDataForCards.value);
    cards.value = getCards();
});

const getAffiliateInfo = async () => {
    try {
        const dto = {
            search: props.invoice.affiliate_id,
            fields: ['email', 'phone'],
        };
        const { data } = await getAffiliateSearch(dto);
        affiliate.value = data[0];
    } catch (err) {
        showServerError(err, 'Ошибка получения партнёра');
    }
};

const getDataForCards = computed<AffiliateInvoiceInfo>(() => {
    const inv = props.invoice;
    const aff = affiliate.value;
    return {
        affiliate_id: inv?.affiliate_id,
        email: aff?.email ?? '',
        manager: inv?.name ?? '',
        phone: aff?.phone ?? '',
        currency: inv?.currency ?? '',
        payment_period: inv?.pay_period ?? '',
        payment_method: inv?.paid_by_payment_method.name.ru ?? '',
        requisite: getRequisite(inv?.paid_by_payment_method.requisite, inv?.paid_by_payment_method.method_id),
        current_payment_method: inv?.current_payment_method.name.ru ?? '',
        current_requisite: getRequisite(inv?.current_payment_method.requisite, inv?.current_payment_method.method_id),

        revenue: inv?.total_revenue,
        amount: inv?.total_amount,
        profit: inv?.total_profit,
        margin: inv?.margin,
        paid: inv?.partials_amount,
        rest: inv?.rest_amount,
    };
});

const getRequisite = (item: any, method_id: string): string => {
    const requisites: (string | number)[] = item instanceof Object ? Object.values(item) : [item];

    if (method_id === "contract_v1") {
        return item.legal_name;
    } else {
        return requisites.join(', ') || '';
    }
};

return { __sfc: true,props, affiliate, cards, getAffiliateInfo, getDataForCards, getRequisite, BaseEditableCard, BaseListV2 }
}

})